import { Modal, Button } from "antd";
import { Form, Input, Select, DatePicker, message, InputNumber } from "antd";
import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

class ExternalUserForm extends React.Component {
  state = {
    loading: false,
    visible: false,
    selectedFile: [],
    selectValues: [],
    category: "",
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  onFinish = (values) => {
    const PatientId = this.props?.id
      ? this.props?.id
      : localStorage.getItem("userid");

    const url = `https://app02.thbglobal.com/v1/externalUserManagement`;

    let data = {
      // appointment_id: 0,
      patient_first_name: values.user["firstname"],
      patient_last_name: values.user["lasttname"],
      patient_email: values.user["email"],
      patient_gender: values.user["gender"],
      patient_dob: values["dob"].format("YYYY-MM-DD"),
      patient_city: values.user["city"],
      patient_country: values.user["country"],
      patient_mobile: values.user["phone"],
      patient_signup_code: values.user["signupCode"],
    };
    this.handleOk();

    axios
      .post(url, data, {
        headers: {
          "x-api-key": `Bearer ${JSON.parse(localStorage.getItem("tokens"))}`,
        },
      })
      .then((res) => {
        if (res.statusText === "OK") {
          message.success("User Created Successfully");
          this.setState({ loading: false, visible: false });
          this.props.fetchExternalUserManagementData();
        }
      })
      .catch((err) => message.error("Error Creating User"));
  };

  setValue = (val) => {
    this.setState({ category: val });
  };

  render() {
    const { visible, loading } = this.state;
    return (
      <>
        <PlusOutlined type="primary" onClick={this.showModal}>
          Add External User
        </PlusOutlined>

        <Modal
          visible={visible}
          title="Add New Record"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={800}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              Return
            </Button>,
          ]}
        >
          <Form
            {...layout}
            name="nest-messages"
            onFinish={(values) => this.onFinish(values)}
            validateMessages={validateMessages}
          >
            <Form.Item
              name={["user", "firstname"]}
              label="First Name"
              rules={[
                {
                  required: true,
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "lastname"]}
              label="Last Name"
              rules={[
                {
                  required: true,
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "email"]}
              label="Email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "gender"]}
              label="Gender"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select allowClear onChange={this.setValue} required="true">
                <Option value="Male">Male</Option>
                <Option value="Female">Female</Option>
                <Option value="Other">Other</Option>

                {/* <Cascader options={this.values} /> */}
              </Select>
            </Form.Item>

            <Form.Item
              name="dob"
              label="Date of Birth"
              initialValue={moment()}
              rules={[
                {
                  type: "object",
                  required: true,
                  message: "Please select time!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              name={["user", "city"]}
              label="City"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "country"]}
              label="Country"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "phone"]}
              label="Phone"
              rules={[
                {
                  required: true,
                  message: "Please input your phone number!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "signupCode"]}
              label="Signup Code"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}

export default ExternalUserForm;
